import waves from './waves'

// 注意：我们不在此处注册全局指令，而是在 main.js 中注册

export default waves


// WEBPACK FOOTER //
// ./src/directive/waves/index.js